import { useEffect } from 'react';
import { connect } from 'react-redux';

import { isWidgetVisible } from '../../features/widget/redux/widget.redux';
import type { State } from '../../reducers';
import { dataLayerPush, type GoogleTagManagerEvent } from './googleTagManager';

interface VisibilityTrackerGoogleAnalyticsProps {
    googleAnalyticsEvent: GoogleTagManagerEvent;
}

interface VisibilityTrackerVisibleProps {
    componentIsVisible: boolean;
}

export const VisibilityTrackerComponent = (
    props: VisibilityTrackerGoogleAnalyticsProps & VisibilityTrackerVisibleProps
): null => {
    const { googleAnalyticsEvent, componentIsVisible } = props;
    useEffect(() => {
        if (componentIsVisible) {
            dataLayerPush(googleAnalyticsEvent);
        }
    }, [componentIsVisible]);
    return null;
};

const mapStateToProps = (state: State): VisibilityTrackerVisibleProps => ({
    componentIsVisible: isWidgetVisible(state),
});

export const WidgetVisibilityTrackerContainer = connect(mapStateToProps)(VisibilityTrackerComponent);
